import { useTranslation } from 'react-i18next';
import { DateFormatter } from 'infrastructure/functions';

import s from '../style.module.scss';

import type { FC } from 'react';
import type { InteractiveTimeItem } from 'infrastructure/hooks/interactiveTimeDashboard/types';

interface Props {
  record: InteractiveTimeItem;
}

export const InteractionFlag: FC<Props> = ({ record }) => {
  const { t } = useTranslation();

  if (record.patientInteractionStatus !== true) {
    return (
      <div
        className={s.interactionStatus}
        data-cy="interactiveTimeDashboard-interactionFlag"
      >
        {t('interactiveTimeDashboard.false')}
      </div>
    );
  }

  return (
    <div
      className={s.interactionStatus}
      data-cy="interactiveTimeDashboard-interactionFlag"
    >
      {record.lastInteractionStatusChangedByUserType === 'practice'
        ? t('interactiveTimeDashboard.trueByClinic')
        : t('interactiveTimeDashboard.true')}
      {record.lastInteractionStatusChange && (
        <span className={s.date}>
          {t('labels.flagSet')}: <br />
          {DateFormatter({ date: record.lastInteractionStatusChange })}
        </span>
      )}
    </div>
  );
};
